import AModal, { FooterBtnCommonProps } from '@/components/A/AModal/AModal'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import styles from './CommonModal.module.less'

export interface CommonModalProps {
  title: string
  content: string | React.ReactNode
  onConfirm?: () => void
  onCancel?: () => void
  onClose?: () => void
  confirmText?: string
  cancelText?: string
  confirmBtnProps?: FooterBtnCommonProps
  cancelBtnProps?: FooterBtnCommonProps
  closable?: boolean
}

function CommonModal(props: CommonModalProps) {
  const modal = useModal()

  return (
    <AModal
      {...props}
      open={modal.visible}
      className={styles.commonModal}
      width={610}
      onConfirm={() => {
        props.onConfirm?.()
        modal.hide()
      }}
      onCancel={() => {
        props.onCancel?.()
        modal.hide()
      }}
      afterClose={() => {
        modal.remove()
      }}
    >
      {
        typeof props.content === 'string' ? (
          <p className={styles.simpleBrief}>{props.content}</p>
        ) : props.content
      }
    </AModal>
  )
}

export default NiceModal.create(CommonModal)
